<template>
  <div>
    <div v-show="loading" class="">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
      <div class="chart_text">{{ $t("generic.loading_items") }}</div>
    </div>

    <div v-show="!loading && !emptyData" class="chart" id="chart"></div>

    <div v-if="emptyData" class="chart_text">{{ $t("generic.no_data_available") }}</div>
  </div>
</template>

<script>
  export default {
    name: "VaApexChart",
    props: {
      seriesOptions: {
        type: Array,
        required: true,
        default: () => [],
      },
      xaxisValues: {
        type: Array,
        required: true,
        default: () => [],
      },
      colors: {
        type: Array,
        required: false,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        apexChart: "",
      };
    },
    watch: {
      xaxisValues: {
        handler(newVal) {
          if (newVal.length) {
            this.apexChart.updateOptions(this.chartOptions);
          }
        },
      },
    },
    computed: {
      shouldRenderChart() {
        return this.seriesOptions.length && this.xaxisValues.length;
      },
      emptyData() {
        return !this.shouldRenderChart && this.loading === false;
      },
      chartOptions() {
        return {
          series: this?.seriesOptions || [],
          chart: {
            type: "line",
            height: 350,
            zoom: {
              enabled: false,
            },
            stacked: false,
          },
          colors: this.colors || [],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "straight",
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
          },
          xaxis: {
            type: "category",
            categories: this?.xaxisValues || [],
          },
        };
      },
    },
    async mounted() {
      this.initChart();
    },
    methods: {
      initChart() {
        // eslint-disable-next-line no-undef
        this.apexChart = new ApexCharts(document.querySelector("#chart"), this.chartOptions);
        this.apexChart.render();
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";

  .chart {
    border: none !important;
    margin: 0 !important;

    &_text {
      padding: 8px;
      text-align: center;
      font-size: 14px;
    }
    &::v-deep {
      .apexcharts-legend-text {
        color: get-color("subtitle") !important;
        font-size: 14px !important;
        padding-left: 20px !important;
      }

      .apexcharts-text {
        &.apexcharts-yaxis-label,
        &.apexcharts-xaxis-label {
          fill: get-color("body") !important;
        }
      }

      .apexcharts-tooltip {
        &.apexcharts-theme-light {
          background: get-color("hover") !important;

          .apexcharts-tooltip-title {
            background: get-color("background") !important;
          }
        }
      }
    }
  }
</style>
